import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";
import config from "emun.invoice/invoice.config";
import creditRequestConfig from "emun.invoice/credit-request/credit-request.config"

const realm = "ReturnRequest";
const mediaParent = line => `${line.requestId}/${line.position}`;

export default class ReturnItemPromptController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		Object.assign($ctrl, options);
		$ctrl.reasonCodes = config.reasonCodes;
		$ctrl.creditRequestConfig = creditRequestConfig;
		$ctrl.realm = realm;
		$ctrl.tagCriteria = {
			$creditmemoId: options.creditmemo.id,
			$invoiceLineNumber: "" + options.line.invoiceLineNumber
		};
		$ctrl.line = Object.assign(
			{
				requestId: options.creditmemo.id
			},
			options.line,
			{
				qtyReturned: undefined
			}
		);
		$ctrl.bus = new ServiceBus();
		$ctrl.line.quantity = Math.max(
			options.line.quantity,
			options.line.qtyReturned,
			1
		);
		console.debug("line", options.line, $ctrl.line, $ctrl);
	}

	save(close) {
		const $ctrl = this;

		if ($ctrl.line.id) {
			if ($ctrl.line.quantity > 0) {
				if (($ctrl.creditRequestConfig.requireImage && $ctrl.line.quantity >= $ctrl.creditRequestConfig.requireImage) || ($ctrl.creditRequestConfig.requireImageReasonCodes && $ctrl.creditRequestConfig.requireImageReasonCodes.indexOf($ctrl.line.reasonCode) > -1)) {
					$ctrl.bus.read("QueryMedia.json", {
						realm: $ctrl.realm,
						tagCriteria: $ctrl.tagCriteria,
						Active: true
					}).then(res => {
						//console.info("BL*** media results = ", res);
						if (res.data.results.length === 0) {
							modals.alert("Please upload an image of your item to complete this claim request");
							return;
						} else {
							return $ctrl.bus
							.send("UpdateCreditMemoRequestLine.json", $ctrl.line)
							.then(() => {
								if (close) {
									$ctrl.$close($ctrl.model);
								}
							});
						}
					});
				} else {
					return $ctrl.bus
					.send("UpdateCreditMemoRequestLine.json", $ctrl.line)
					.then(() => {
						if (close) {
							$ctrl.$close($ctrl.model);
						}
					});
				}				
			} else {
				return modals
					.confirm("Are you sure?", "Delete credit line")
					.result.then(function () {
						$ctrl.bus
							.send("DeleteCreditMemoRequestLine.json", $ctrl.line)
							.then(() => {
								if (close) {
									$ctrl.$close($ctrl.model);
								}
							});
					});
			}
		} else {
			if (($ctrl.creditRequestConfig.requireImage && $ctrl.line.quantity >= $ctrl.creditRequestConfig.requireImage) || ($ctrl.creditRequestConfig.requireImageReasonCodes && $ctrl.creditRequestConfig.requireImageReasonCodes.indexOf($ctrl.line.reasonCode) > -1)) {
				$ctrl.bus.read("QueryMedia.json", {
					realm: $ctrl.realm,
					tagCriteria: $ctrl.tagCriteria,
					Active: true
				}).then(res => {
					//console.info("BL*** media results = ", res);
					if (res.data.results.length === 0) {
						modals.alert("Please upload an image of your item to complete this claim request");
						return;
					} else {
						return $ctrl.bus
							.send("CreateCreditMemoRequestLine.json", $ctrl.line)
							.then(() => {
								if (close) {
									$ctrl.$close($ctrl.model);
								}
							});
					}
				});
			} else {
				return $ctrl.bus
					.send("CreateCreditMemoRequestLine.json", $ctrl.line)
					.then(response => {
						$ctrl.line.id = response.data.id;
						if (close) {
							$ctrl.$close($ctrl.model);
						}
					});
			}
		}
	}

	incrementQty() {
		let $ctrl = this;
		if ($ctrl.line.quantity < $ctrl.line.qtyShipped) {
			$ctrl.line.quantity += 1;
		}
	}
	decrementQty() {
		let $ctrl = this;
		if ($ctrl.line.quantity > 0) {
			$ctrl.line.quantity -= 1;
		}
	}

	submit() {
		const $ctrl = this;
		$ctrl.save(true);
	}

	dismiss() {
		const $ctrl = this;
		//$ctrl.$emit('activitySaved', $ctrl);
		$ctrl.$dismiss();
	}
}
